import { render, staticRenderFns } from "./homeSwiper.vue?vue&type=template&id=a29f9316&scoped=true"
import script from "./homeSwiper.vue?vue&type=script&lang=js"
export * from "./homeSwiper.vue?vue&type=script&lang=js"
import style0 from "./homeSwiper.vue?vue&type=style&index=0&id=a29f9316&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29f9316",
  null
  
)

export default component.exports